module.exports = "/img/city-copenhagen.b26bae94.jpg";